import { render, staticRenderFns } from "./WelcomeGreeting.vue?vue&type=template&id=59bd8d64&scoped=true&"
import script from "./WelcomeGreeting.vue?vue&type=script&lang=js&"
export * from "./WelcomeGreeting.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeGreeting.vue?vue&type=style&index=0&id=59bd8d64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bd8d64",
  null
  
)

export default component.exports